// Kulintara logo: spoon + fork crossed forming "K" with a subtle Nusantara wave
// Used across header, footer, and favicon
const Logo = ({ size = 36, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    aria-label="Kulintara"
  >
    <defs>
      <linearGradient id="kulintaraGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#D96C4A" />
        <stop offset="100%" stopColor="#E89968" />
      </linearGradient>
    </defs>
    {/* Rounded plate background */}
    <rect x="2" y="2" width="60" height="60" rx="14" fill="url(#kulintaraGrad)" />

    {/* Nusantara archipelago wave (3 islands silhouette) at bottom */}
    <path
      d="M8 50 Q14 46, 20 50 T32 50 T44 50 T56 50 L56 56 L8 56 Z"
      fill="rgba(255,255,255,0.18)"
    />
    <path
      d="M8 53 Q14 50, 20 53 T32 53 T44 53 T56 53 L56 56 L8 56 Z"
      fill="rgba(255,255,255,0.25)"
    />

    {/* Spoon (left, tilted) */}
    <g transform="rotate(-30 32 32)">
      {/* spoon bowl */}
      <ellipse cx="22" cy="14" rx="6" ry="8" fill="#FFF" />
      <ellipse cx="22" cy="14" rx="3.5" ry="5.5" fill="url(#kulintaraGrad)" opacity="0.25" />
      {/* spoon handle */}
      <rect x="20.5" y="20" width="3" height="28" rx="1.5" fill="#FFF" />
    </g>

    {/* Fork (right, tilted opposite) */}
    <g transform="rotate(30 32 32)">
      {/* fork tines */}
      <rect x="40" y="8" width="1.5" height="11" rx="0.7" fill="#FFF" />
      <rect x="43" y="7" width="1.5" height="12" rx="0.7" fill="#FFF" />
      <rect x="46" y="8" width="1.5" height="11" rx="0.7" fill="#FFF" />
      {/* fork base */}
      <path d="M39 19 L49 19 L48 23 L40 23 Z" fill="#FFF" />
      {/* fork handle */}
      <rect x="42.5" y="22" width="3" height="26" rx="1.5" fill="#FFF" />
    </g>
  </svg>
);

export default Logo;
